import { Component, ReactNode } from "react";

interface Props { children: ReactNode; }
interface State { hasError: boolean; error?: Error; }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" style={{ padding: "24px 0", textAlign: "center" }}>
          <div style={{ fontSize: 15, fontWeight: 500, color: "var(--red)", marginBottom: 6 }}>Anzeigefehler</div>
          <div className="mono" style={{ fontSize: 11, color: "var(--text-faint)", marginBottom: 16 }}>
            {this.state.error?.message}
          </div>
          <button className="btn btn-secondary"
            onClick={() => this.setState({ hasError: false })}
            style={{ height: 44, padding: "0 16px", border: "1px solid var(--border-strong)", color: "var(--text)" }}>
            Neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
